import { useEffect, useState } from "react";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import ReportType from "./ReportType";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";
import { useLazyGetAllUserByTenantQuery } from "../../../user/users/usersApi";
import { getDatesDifferenceInDays } from "../../../../helpers/utils/DatesDifferenceInDays";
import { useNavigate } from "react-router-dom";
import { useLazyExportDetailedUserEfficencyReportDataQuery, useSearchDetailedUserEfficReportApiQuery } from "../report";
import { useUtilDataQuery } from "../../../profile/profileApi";
import { getCurrentMonthStartDate } from "../../../../helpers/utils/Utils";



const DetailedUserEfficiencyReport = () => {

    const tenantData = useGetAllTenantsQuery("");
    const [type, setType] = useState('DETAILED_USER_EFFICIENCY_REPORT');
    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Report Detailed User Efficiency");
    const [userTenantApi, userTenantApiResponse] = useLazyGetAllUserByTenantQuery();
    const { data: utilData } = useUtilDataQuery("");
        const formattedStartDate = getCurrentMonthStartDate();
    

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Detailed User Efficiency Report", url: "" }]
    )
    const [triggerExportReportDataQuery] = useLazyExportDetailedUserEfficencyReportDataQuery();
    const navigate = useNavigate();
    useEffect(() => {
        let tenant = utilData?.customerLevel === 'SYS' ? "" : utilData?.tenant;
        if (tenant != null && tenant !== '' && tenant !== undefined) {
            userTenantApi(tenant);
        }
    });


    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "customerOrderNumber",
            visibility: { hasShowSetting: false },
            cell: (props: any) => {
                const path = `/orders/${props.row.original.orderId}`;

                return (
                    <>
                        <i
                            className="fa fa-filter ml-0 pr-1 fa-icon-color cursor_hover"
                            aria-hidden="true"
                            onClick={() =>
                                navigate("/order-events", {
                                    state: { detail: { orderNumber: props.value } },
                                })
                            }
                        />
                        {createClickableLink(path, props.value, userSetting)}
                    </>
                );
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Order No..."}
                    name={"orderNumber"}
                    accessor={"orderNumber"} />,
                overrideFilterAccessor: "orderNumber"
            }]
        },
        {
            label: "Reorder", accessor: "reorderNumber", canSort: false
        },
        {
            label: "Tenant",
            accessor: "tenant",
            overrideSortColumn: "tenant",
            visibility: { hasShowSetting: false, canColumnShow: false },
            filterOptions: [{
                dependentColumns: ["Assignee"],
                filterComponent: SearchSelectWithList(tenantData?.data, (tenant: { name: any; }) => `${tenant.name}`, "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
            }],
        },
        {
            label: "Assignee",
            accessor: "user",
            overrideSortColumn: "assigned_to",
            visibility: { hasShowSetting: false },
            filterOptions: [
                {
                    filterComponent: SearchSelectWithList(userTenantApiResponse?.data, (user: { username: any; }) => `${user.username} `, "username", "Select Assignee(s)...", true, "assigneeList"),
                    onDependencyUpdated: (value: any) => {
                        userTenantApi(value)
                    },
                    overrideFilterLabel: "Assignee(s)",
                    overrideFilterAccessor: "assigneeList",
                }]
            ,

        },

        {
            label: "Product Type",
            accessor: "productType",
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"}
                />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"}
                />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]

        },
        {
            label: "Customer", accessor: "customer", canSort: false
        },
        {
            label: "State", accessor: "state", canSort: false
        },
        {
            label: "County", accessor: "county", canSort: false
        },
        {
            label: "Assigned On", accessor: "assignedOn", canSort: false,
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.assignedOn, "MM/DD/YY");
            }
        },
        {
            label: "Unassigned On ", accessor: "unAssignedOn", canSort: false,
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.unAssignedOn, "MM/DD/YY");
            }
        },
        {
            label: "Completed On", accessor: "completedOn", canSort: false,
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.completedOn, "MM/DD/YY");
            }
        },
        {
            label: "Delivered On", accessor: "deliveredOn", canSort: false,
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.deliveredOn, "MM/DD/YY");
            }
        },
        {
            label: "Assigned Duration", accessor: "assignedDuration", canSort: false,
            cell: (props: any) => {
                return props.row.original.assignedDuration;
            }
        },
        {
            label: "Completed Time", accessor: "completedTime", canSort: false,
            cell: (props: any) => {
                return getDatesDifferenceInDays(props.row.original.assignedOn, props.row.original.completedOn);
            }
        }, {
            label: "Delivered Time ", accessor: "deliveredTime", canSort: false,
            cell: (props: any) => {
                return getDatesDifferenceInDays(props.row.original.completedOn == null ? props.row.original.assignedOn : props.row.original.completedOn, props.row.original.deliveredOn);
            }
        },

    ];

    const customFilter = {
        createdDateFrom: formattedStartDate,
    }

    return (
        <>


            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchDetailedUserEfficReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }}
                    defaultSortOptions={{
                        accessor: "assigned_to",
                        direction: "asc"
                    }}
                    defaultFilter={
                        {
                            ...customFilter,
                            "sortOrder": "ASCENDING",
                            "pageNumber": 0,
                            "pageSize": "15",
                            "sort": "assigned_to"
                        }
                    }
                    userSettingGroup={"Report-DetailedUserEfficiency"}
                    basePermission={"DETUSRREPO"}
                />
            </div>
            <div />
        </>
    )


}


export default DetailedUserEfficiencyReport;